import React, { useEffect, useState } from "react";
import {
  Table,
  Box,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Switch,
  Stack,
  FormControl,
  Autocomplete,
  TextField,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Checkbox,
  FormControlLabel,
  Pagination,
  TablePagination,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import MapIcon from "@mui/icons-material/Room";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useNavigate } from "react-router-dom";
import edit from "../../../assets/images/editIcon.png";
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import {
  ApiPutVenueStatus,
  ApiGetVenueList,
  ApiGetClientEntityByClientGroupId,
  ApiQuizreTake,
} from "../../../apiService/Core/Apicall.tsx";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "../../../global/config/store.ts";
import PatchedReactQuill from "./PatchedReactQuill.tsx";
const ManageVenue: React.FC = () => {
  const [venues, setVenues] = useState<any[]>([]);
  const [status, setStatus] = useState({});
  const [clientEntityList, setClientEntityList] = useState<any>([]);
  const [clientEntityId, setClientEntityId] = useState<any>(null);
  const Clientlist = useSelector((state: RootState) => state.client.clientList);
  const [selectedClient, setSelectedClient] = useState<any>(null);
  const [ClientId, setClientId] = useState(null);
  const [OpenEditDescription, setOpenEditDescription] = useState<boolean>(false)
  const [isResetQuiz, setisResetQuiz] = useState<boolean>(false)
  const [editorValue, setEditorValue] = useState<any>("");
  const [editedvenueId, seteditedvenueId] = useState<string | number>("");
  const [editedclientEntityId, seteditedclientEntityId] = useState<number>();
  const [datalength, setdatalength] = useState<any>(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);


  useEffect(() => {
    if (Clientlist.length > 2) {
      setSelectedClient(Clientlist[2]);
      setClientId(Clientlist[2].clientGroupName);
    }
  }, [Clientlist]);

  useEffect(() => {
    if (clientEntityList.length > 1) {
      setClientEntityId(clientEntityList[0]?.clientEntityId);
    }
  }, [clientEntityList]);

  useEffect(() => {
    handleGetClientList();
  }, [ClientId]);

  const handleGetClientList = async () => {
    const data = `?ClientGroupName=${ClientId}`;
    if (!ClientId) return;
    try {
      const res: any = await ApiGetClientEntityByClientGroupId(data);
      setClientEntityList(res.data);
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const navigate = useNavigate();

  const addOrUpdateVenue = (venue?: any) => {
    if (venue) {
      navigate(`/admin/add-or-update-venue/update/${venue?.venueId}`, {
        state: { venueData: venue },
      });
    } else {
      navigate("/admin/add-or-update-venue/add");
    }
  };

  const [isDialogOpen, setDialogOpen] = useState(false);

  const [selectedVenue, setSelectedVenue] = useState<any>(null);
  const handleOpenMap = (venue) => {
    setSelectedVenue(venue);
    setDialogOpen(true);
  };

  const openMapInNewTab = (venue: any) => {
    const url = "/venue-map?id=1&lat=-25.2744&lng=133.7751";
    window.open(url, "_blank"); // Open map page in a new tab
  };

  // const openMapInNewTab = (venue: any) => {
  //   const url = `https://www.google.com/maps?q=-25.2744,133.7751&z=15`;
  //   window.open(url, "_blank"); // Open map page in a new tab
  // };

  useEffect(() => {
    const fetchData = async () => {
      clientEntityId && await handleGetVenueList();
    };
    fetchData();
    return () => { };
  }, [clientEntityId, selectedClient,rowsPerPage, page]);

  const handleGetVenueList = async () => {
    const data = `?offset=${page * rowsPerPage}&limit=${rowsPerPage}${clientEntityId !== null ? `&clientEntityId=${clientEntityId}` : ''}${selectedClient !== null ? `&clientGroupName=${selectedClient.clientGroupName}` : ''}`;
    try {
      const response: any = await ApiGetVenueList(data);
      setVenues(response.data);
      setdatalength(response.totalDataCount);
      console.log("venue list", response.data);
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const deleteVenue = async (venue: any, newStatus: string) => {
    try {
      const body = {
        venueId: venue?.venueId,
        status: newStatus,
      };
      const response: any = await ApiPutVenueStatus(body);
      toast.success("Site Deleted successfully!");
      console.log("Status updated successfully:", response);
      handleGetVenueList();
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const navigateToViewJobCriteriaVenue = (venue?: any) => {
    navigate("/admin/view-venue-jobcriteria", {
      state: { venue },
    });
  };
  const navigateToVenueSiteQuestion = (venue?: any) => {
    navigate("/admin/create-venue-site-template", {
      state: { venue },
    });
  };

  const navigateToViewEditors = (venue?: any) => {
    navigate("/admin/view-editor-site", {
      state: { venue },
    });
  };

  const handleChange = async (venue: any, newStatus: string) => {
    setStatus((prevStatus) => ({
      ...prevStatus,
      [venue.venueId]: newStatus,
    }));

    setVenues((prevList) =>
      prevList.map((item) =>
        item.venueId === venue.venueId
          ? {
            ...item,
            venueStatus: {
              ...item.userStatus,
              userStatus: newStatus,
            },
          }
          : item
      )
    );

    try {
      const body = {
        venueId: venue?.venueId,
        status: newStatus,
      };
      const response: any = await ApiPutVenueStatus(body);
      console.log("Status updated successfully:", response);
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const quizretake = async () => {
    const data = {
      "clientEntityId": editedclientEntityId,
      "venueId": editedvenueId,
      "venueDescription": editorValue,
      "retakeRequired": isResetQuiz
    }
    // console.log("ENd Values",)
    try {
      const response = await ApiQuizreTake(data)
      toast.success(response.message)
      handleGetVenueList()

    }
    catch (error) {
      toast.error(error)
    }
    finally {
      setOpenEditDescription(false)
    }
  }

  // ------------------------------------------- Chnage Pagination -----------------------------------------------
    const handleChangePage = (_event: unknown, newPage: number) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (
      event: React.ChangeEvent<HTMLInputElement>
    ) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    }; 
  return (
    <div className="manage-admin-container">
      <div className="manage-button">

        <Stack direction="row" className="ml-2" spacing={2}>
          <FormControl size="small" sx={{ width: 180 }}>
            <Autocomplete
              disablePortal
              id="mm-autocomplete"
              options={Clientlist}
              value={selectedClient}
              getOptionLabel={(option) => option?.clientGroupName}
              isOptionEqualToValue={(option, value) =>
                option.clientGroupDBName === value.clientGroupDBName
              }
              onChange={(event, newValue: any) => {
                setSelectedClient(newValue);
                setClientId(newValue?.clientGroupName || null);

                if (!newValue || (selectedClient && newValue.clientGroupName !== selectedClient.clientGroupName)) {
                  setClientEntityId(null)
                  setClientEntityList([])
                }
              }}
              renderInput={(params) => (
                <TextField {...params} label="Select Client" />
              )}
              size="small"
            />
          </FormControl>
        </Stack>
        <Stack className="ml-2" direction="row" spacing={2}>
          <FormControl size="small" sx={{ width: 400 }}>
            <Autocomplete
              disablePortal
              id="beacon-autocomplete"
              options={clientEntityList.filter(
                (item) => item.clientEntityId !== null
              )} // filter out invalid entries
              getOptionLabel={(option) => option?.entityName || ""} // properly show label
              onChange={(event, newValue: any) => {
                setClientEntityId(newValue?.clientEntityId || null);
              }}
              value={
                clientEntityList.find(
                  (option) => option?.clientEntityId === clientEntityId
                ) || null
              }
              defaultValue={clientEntityList[0]?.clientEntityId}
              renderInput={(params) => (
                <TextField {...params} label="Select Business" />
              )}
              size="small"
            />
          </FormControl>
        </Stack>
        <h1 className="common-manage-h1 pl-4">Manage Sites</h1>
        <div className="add-button common-manage-button">
          <Button
            variant="contained"
            onClick={() => addOrUpdateVenue()}
            className="table-row-background "
          >
            Add New Site
          </Button>
          {/* <Button
          variant='contained'
          onClick={() => addOrUpdateVenue()}
          className='table-row-background '
          style={{ marginLeft: '10px' }}
        >
          Add New Report
        </Button> */}
        </div>{" "}
      </div>
      <Table>
        <TableHead>
          <TableRow className="table-row-background">
            {/* <TableCell style={{ color: "#fff" }}>XLS</TableCell> */}
            <TableCell style={{ color: "#fff" }}>Venue Name</TableCell>
            <TableCell style={{ color: "#fff" }}>Venue Code</TableCell>
            <TableCell style={{ color: "#fff" }}>State</TableCell>
            <TableCell style={{ color: "#fff", paddingLeft: "50px" }}>
              Editor
            </TableCell>
            <TableCell style={{ color: "#fff", paddingLeft: "35px" }}>
              Job Criteria
            </TableCell>
            <TableCell style={{ color: "#fff", paddingLeft: "35px" }}>
              Questions
            </TableCell>
            <TableCell style={{ color: "#fff" }}>Active</TableCell>
            {/* <TableCell style={{ color: "#fff" }}>Copy Brief</TableCell>
            <TableCell style={{ color: "#fff" }}></TableCell> */}
            <TableCell style={{ color: "#fff" }}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {venues.map((venue) => (
            <TableRow key={venue.id}>
              {/* <TableCell>
                <Button variant="contained" className="table-row-background">
                  {" "}
                  Upload
                </Button>
              </TableCell> */}
              <TableCell>{venue.venueName}</TableCell>
              <TableCell>{venue.venueCode}</TableCell>
              <TableCell>{venue.state}</TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  onClick={() => navigateToViewEditors(venue)}
                  className="table-row-background"
                >
                  View Editors
                </Button>
              </TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  onClick={() => navigateToViewJobCriteriaVenue(venue)}
                  className="table-row-background"
                >
                  Job Criteria
                </Button>
              </TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  onClick={() => navigateToVenueSiteQuestion(venue)}
                  className="table-row-background"
                >
                  Questions
                </Button>
              </TableCell>
              <TableCell>
                <div className="switch-admin">
                  <Switch
                    checked={venue?.venueStatus?.userStatus === "active"}
                    onChange={(e) => {
                      const newStatus = e.target.checked
                        ? "active"
                        : "inActive";
                      handleChange(venue, newStatus); // Pass the store and the new status
                    }}
                    sx={{
                      '& .MuiSwitch-thumb': {
                        backgroundColor: venue?.venueStatus?.userStatus === "active" ? "#1976d2" : "#ccc !important"
                      },
                      '& .MuiSwitch-track': {
                        backgroundColor: venue?.venueStatus?.userStatus === "active" ? "#90caf9" : "#ccc"
                      }
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />{" "}
                </div>
              </TableCell>
              <TableCell className="d-flex justify-content-start">
                <Button
                  // variant="contained"
                  onClick={() => { setOpenEditDescription(true); if (venue) { setEditorValue(venue.venueDescription); seteditedvenueId(venue.venueId); seteditedclientEntityId(venue.clientEntityId.clientEntityId) } }}
                  startIcon={<ContentCopyIcon />}
                // className="table-row-background"
                ></Button>
                <Button
                  // variant="contained"
                  // className="table-row-background"
                  onClick={() => addOrUpdateVenue(venue)}
                >
                  <Box component="img" className="w-50" src={edit}></Box>
                </Button>
                <Button
                  variant="contained"
                  className="delete-transparent"
                  onClick={() => {
                    const isConfirmed = window.confirm(
                      "Are you sure you want to delete the Site?"
                    );
                    if (isConfirmed) {
                      deleteVenue(venue, "delete"); // Call the API or action
                    }
                  }}
                >
                  <DeleteIcon className="delete-icon" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={datalength}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      {/* -----------------------------------------------------------------Edit Description --------------------------- */}

      <Dialog open={OpenEditDescription}
        PaperProps={{
          sx: {
            width: '900px',
            height: 'fit-content',
            maxWidth: 'none'
          }
        }}
      >
        <DialogContent className="p-3 d-flex flex-column gap-5">
          <Box className='d-flex align-items-center justify-content-between'>
            <Typography className="fw-bold" variant="h5">Update Job Description</Typography>
            <IconButton onClick={() => { setOpenEditDescription(false) }}>
              <CancelOutlinedIcon />
            </IconButton>
          </Box>
          <Box className='mt-3'>
            <PatchedReactQuill
              setEditorValue={setEditorValue}
              editorValue={editorValue}
              isUpdate={false}
            />
          </Box>
          <FormControlLabel className="my-1" control={<Checkbox checked={isResetQuiz} onChange={() => { setisResetQuiz(!isResetQuiz) }} />} label="Reset quiz for this business" />
          <Button variant="contained" onClick={quizretake}
            className="table-row-background my-1 mx-auto" sx={{ width: 'fit-content', textTransform: 'none' }}>Submit</Button>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ManageVenue;
